
    /* AppDynamics EUM */
    window['adrum-start-time'] = new Date().getTime();
    (function (config) {
      if (window.__INITIAL_STATE__) {
        config.appKey = window.__INITIAL_STATE__.appDynamicsAppKey;
        config.adrumExtUrlHttp = window.__INITIAL_STATE__.appDynamicsAdrumExtUrlHttp;
        config.adrumExtUrlHttps = window.__INITIAL_STATE__.appDynamicsAdrumExtUrlHttps;
        config.beaconUrlHttp = window.__INITIAL_STATE__.appDynamicsBeaconUrlHttp;
        config.beaconUrlHttps = window.__INITIAL_STATE__.appDynamicsBeaconUrlHttps;
        config.xd = { enable: false };
      } else {
        console.error('window.__INITIAL_STATE__ is not defined.');
      }
    })(window['adrum-config'] || (window['adrum-config'] = {}));

    // Lucky Orange
    if (window.__INITIAL_STATE__ && window.__INITIAL_STATE__.enableLuckyOrange === true) {
      console.log('intializing Lucky-Orange in 5 seconds');
      window.setTimeout(() => {
        console.log('startup: initializing Lucky-Orange');
        (function () {
          var wa = document.createElement('script');
          wa.type = 'text/javascript';
          wa.async = true;
          wa.src = 'https://tools.luckyorange.com/core/lo.js?site-id=0bc57cdb';
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(wa, s);
        })();
      }, 5000);
    }

    // One Trust
    if (window.__INITIAL_STATE__ && window.__INITIAL_STATE__.oneTrustScriptDataDomain) {
      console.log('startup: initializing OneTrust');
      (function () {
        var wa = document.createElement('script');
        wa.type = 'text/javascript';
        wa.async = true;
        wa.src = 'https://cdn.cookielaw.org/consent/' + window.__INITIAL_STATE__.oneTrustScriptDataDomain + '/OtAutoBlock.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(wa, s);
      })();

      (function () {
        var wa = document.createElement('script');
        wa.type = 'text/javascript';
        wa.async = true;
        wa.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        wa.setAttribute('data-domain-script', window.__INITIAL_STATE__.oneTrustScriptDataDomain);
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(wa, s);
      })();
    }
  